<template>
  <pf-data-list-item>
    <pf-data-list-cell>
      <server-icon /> {{ server.nome }}
    </pf-data-list-cell>

    <pf-data-list-cell v-if="server.os">
      <pf-title h="4">{{ $t('Sistema operativo') }}</pf-title>
      <p>{{ server.os }} {{ server.osrelease }}</p>
    </pf-data-list-cell>

    <pf-data-list-cell v-if="server.ip4_public">
      <pf-title h="4">{{ $t('Indirizzo IP') }}</pf-title>
      <p>{{ server.ip4_public }}</p>
    </pf-data-list-cell>

    <pf-data-list-cell v-if="server.fqdn">
      <pf-title h="4">{{ $t('Dominio') }}</pf-title>
      <p>{{ server.fqdn }}</p>
    </pf-data-list-cell>

    <pf-data-list-action>
      <pf-flex direction="column" align-items="flex-end" class="pf-v6-u-display-none pf-v6-u-display-flex-on-lg">
        <pf-button v-if="server.cpanel" variant="primary" small :href="`https://${server.fqdn}:2087/`" target="_blank">
          <template #icon><arrow-up-right-from-square-icon /></template>
          {{ $t('Accedi a WHM') }}
        </pf-button>

        <pf-button v-if="server.has_cockpit" variant="primary" small :href="`https://${server.fqdn}/cockpit`" target="_blank">
          <template #icon><arrow-up-right-from-square-icon /></template>
          {{ $t('Accedi a Cockpit') }}
        </pf-button>

        <pf-button v-if="server.has_console" variant="primary" small :href="`/console/?id=${server.id}/`" target="popup" @click.prevent="popup(`/console/?id=${server.id}/`)">
          <template #icon><virtual-machine-icon /></template>
          {{ $t('Apri console') }}
        </pf-button>
      </pf-flex>

      <pf-dropdown>
        <template #toggle>
          <pf-menu-toggle variant="plain" class="pf-v6-u-display-block pf-v6-u-display-none-on-lg">
            <ellipsis-vertical-icon />
          </pf-menu-toggle>
        </template>

        <pf-dropdown-item v-if="server.cpanel" :to="`https://${server.fqdn}:2087/`">
          <template #icon><arrow-up-right-from-square-icon /></template>
          {{ $t('Accedi a WHM') }}
        </pf-dropdown-item>

        <pf-dropdown-item  v-if="server.has_cockpit" :to="`https://${server.fqdn}/cockpit`">
          <template #icon><arrow-up-right-from-square-icon /></template>
          {{ $t('Accedi a Cockpit') }}
        </pf-dropdown-item>
        <pf-dropdown-item  v-if="server.has_console" @click.prevent="popup(`/console/?id=${server.id}/`)">
          <template #icon><virtual-machine-icon /></template>
          {{ $t('Apri console') }}
        </pf-dropdown-item>
      </pf-dropdown>

    </pf-data-list-action>

    <pf-data-list-content>
      <pf-flex v-if="server.server_location || server.backup_location">
        <pf-flex-item grow v-if="server.server_location">
          <pf-title h="4">{{ $t('Location') }}</pf-title>
          <p>{{ server.server_location }}</p>
        </pf-flex-item>

        <pf-flex-item grow v-if="server.backup_location">
          <pf-title h="4">
            {{ $t('Backup') }}
            {{ ' ' }}
            <pf-tooltip>
              <template #content>{{ allFeatures.backup.tooltip }}</template>
              <help-icon />
            </pf-tooltip>
          </pf-title>
          <p>
            {{ $t('Location') }}: {{ server.backup_location }} <circle-icon color="green" :title="$t('Attivo')"/>
          </p>
        </pf-flex-item>
      </pf-flex>
      <pf-empty-state v-else>
        <pf-empty-state-header :title="$t('Nessun dettaglio')" heading-level="h6" />
      </pf-empty-state>
    </pf-data-list-content>
  </pf-data-list-item>
</template>

<script lang="ts" setup>
import type { Server } from '@/resources';
import { getAllProductFeatures } from './product-feature.vue';
import ArrowUpRightFromSquareIcon from '@vue-patternfly/icons/arrow-up-right-from-square-icon';
import ServerIcon from '@vue-patternfly/icons/server-alt-icon';
import VirtualMachineIcon from '@vue-patternfly/icons/virtual-machine-icon';
import CircleIcon from '@vue-patternfly/icons/circle-icon';
import HelpIcon from '@vue-patternfly/icons/help-icon';
import EllipsisVerticalIcon from '@vue-patternfly/icons/ellipsis-vertical-icon';

defineProps<{
  server: Server;
}>();

const allFeatures = getAllProductFeatures();

function popup(url: string, options = 'width=1250,height=1000') {
  window.open(url, 'popup', options);
}
</script>
